export default {"src":"/_next/static/media/hero-section-bg.56e73822.svg","height":2176,"width":4744,"blurWidth":0,"blurHeight":0};